export default {
    // 后台服务器 API 地址
    apiBaseUrl: 'http://sc.gygkhd.fun:8000',

    // 服务器数据接口
    serverDataEndpoint: '/server_data/all'
} 